import { defineComponent as _defineComponent } from 'vue'

import { MetaInfo } from 'vue-meta/types/vue-meta';

const __default__ = {
	name: 'ListArticle',
	metaInfo() {
		return (this as unknown as { head: MetaInfo }).head;
	},
};

import { computed } from 'vue';

import PictureComp from '@/components/picture/PictureComp.vue';
import AuthorInfo from '@/features/editorial/components/AuthorInfo.vue';
import ListArticleList from '@/features/editorial/components/article/list/ListArticleList.vue';
import RelatedArticles from '@/features/editorial/components/article/RelatedArticles.vue';
import ListArticleStats from '@/features/editorial/components/article/list/ListArticleStats.vue';
import AdUnit from '@/components/AdUnit.vue';
import ListOffersComparison from '@/features/editorial/components/ListOffersComparison.vue';
import TrendingArticles from '@/features/editorial/components/article/TrendingArticles.vue';

import { useLanguageStore } from '@/stores/pinia/useLanguageStore';

import { getHeaderImage } from '@/features/editorial/helpers/editorial-helper';

import type { ListArticleData } from '@/features/editorial/types/editorial-types';


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    article: null
  },
  setup(__props: any, { expose }) {

const props = __props as {
	article: ListArticleData;
};

const languageStore = useLanguageStore();



const titleList = computed(() => {
	const node = props.article.mainObjects[0]?.node;
	return node?.__typename === 'GenericTitleList' ? node : null;
});

const listSize = computed(() => titleList.value?.titles.totalCount ?? 0);

const head = computed(() => {
	const headerImage = getHeaderImage(props.article);
	const imageUrl = headerImage.url?.startsWith('/')
		? `https://www.${JW_CONFIG.DOMAIN}${headerImage.url}`
		: headerImage.url;

	return {
		meta: [
			// Base meta info
			{ vmid: 'og:type', property: 'og:type', content: 'article' },
			{ vmid: 'article:author', property: 'article:author', content: props.article.author.content.fullPath },
			{ vmid: 'og:locale', property: 'og:locale', content: languageStore.locale },
			{
				vmid: 'article:published_time',
				property: 'article:published_time',
				content: props.article.content.createdAt,
			},
			{
				vmid: 'article:modified_time',
				property: 'article:modified_time',
				content: props.article.content.updatedAt,
			},

			// Use header image for link previews
			// Disabled until .webp format available
			// { vmid: 'og:image', property: 'og:image', content: imageUrl },
			// { vmid: 'og:image:width', property: 'og:image:width', content: '1400' },
			// { vmid: 'og:image:height', property: 'og:image:height', content: '700' },
			// ...(headerImage.altText
			// 	? [{ vmid: 'og:image:alt', property: 'og:image:alt', content: headerImage.altText }]
			// 	: []),

			// Large format twitter link preview images
			{ vmid: 'twitter:card', name: 'twitter:card', content: 'summary_large_image' },

			// Extra snippets and unfurls for supported platforms
			{ vmid: 'twitter:label1', name: 'twitter:label1', content: 'Written by' },
			{ vmid: 'twitter:data1', name: 'twitter:data1', content: props.article.author.content.clearName },
		],
	};
});

expose({ head });

return { __sfc: true,languageStore, props, titleList, listSize, head, PictureComp, AuthorInfo, ListArticleList, RelatedArticles, ListArticleStats, AdUnit, ListOffersComparison, TrendingArticles, getHeaderImage }
}

})